<template>
    <v-select 
       :value="selected_host" 
       v-bind:items="filteredHosts"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense" 
       :clearable="isClearable"
       :disable-lookup="true"
       @change="updateData">
       <template v-slot:prepend-item>
            <v-list-item>
                <v-list-item-content>
                    <v-text-field v-model="searchHost" placeholder="Search" :clearable="true" :autofocus="true"></v-text-field>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
    </v-select>
</template>

<script>
export default {
    props: {
        selected_host: {
            type: String,
            default: ''
        },              
        label: String,
        field: {
            type: String,
            default: 'eign_code',
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        isDense:{
            type: Boolean,
            default: true
        }
    },
    created() {
        this.getEign();
    },    
    data() {
        return {
            hosts: [],
            searchHost: ''
        }
    },    
    computed:{
      filteredHosts(){
        let owners = this.hosts
        if(this.searchHost){
          owners = owners.filter(x => {
            return x.description.toLowerCase().indexOf(this.searchHost.toLowerCase()) > -1;
          })
        }
        return owners
      }
    },    
    methods: {
        getEign() {
            this.$axios
                .post("ares/json/ares/eign/getEignList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getEign"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error.message);
                    } else {
                        this.hosts = res.data.getEign;
                    }
                })
        },
        updateData(v){
            // the prop must be updated. You cannot do it directly 
            // so you must update the parent field with an emit
            this.$emit('updateData', { "field": this.field, "value": v === null ? '' : v })
            this.searchHost=''; // reset search field
        }
    }
}

</script>